import React from 'react';
import Menu from '../components/common/menu';
import AOS from 'aos';

AOS.init({
    offset: 100,
    // duration: 300,
    easing: 'ease-in-sine',
    once: true,
    delay: 100
});

class App extends React.Component {
    componentWillReceiveProps(nextProps) {
        // if we changed routes...
        if ((
                nextProps.location.key !== this.props.location.key &&
                nextProps.location.state &&
                nextProps.location.state.modal
            )) {
            // save the old children (just like animation)
            this.previousChildren = this.props.children
        }
    }
    render(){
        let { location } = this.props;

        let isModal = (
            location.state &&
            location.state.modal &&
            this.previousChildren
        );
        return(
            <div>
                <Menu location={this.props.location} />
                {isModal ?
                    this.previousChildren :
                    this.props.children
                }
                {isModal && (
                    <div>
                        {this.props.children}
                    </div>
                )}
            </div>    
        );
    }
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/js/components/app.js
 **/